// Dados da empresa configuráveis via admin (serão substituídos por API)
export const companyInfo = {
  name: "Desloca",
  subtitle: "Locadora de Motos",
  logo: "https://customer-assets.emergentagent.com/job_bdae70c3-fcfc-4eba-a30e-28680e4c45c3/artifacts/uf9q7vx0_IMG_2719.jpeg",
  whatsapp: process.env.REACT_APP_WHATSAPP_ADMIN || "5513996208062",
  location: "Praia Grande, São Paulo",
  coverage: "Atendemos toda a Baixada Santista",
  hours: "Segunda a Sexta: 8h às 18h | Sábado: 8h às 16h",
  email: "deslocalocadora@gmail.com",
  cnpj: "60.231.475/0001-10"
};

// NOTA: Dados mock abaixo serão substituídos por dados reais do banco de dados
// Uma vez implementado o CMS admin, estes dados serão removidos

export const rentalPlans = [
  {
    id: 1,
    name: "Plano Mensal",
    dailyPrice: 57.14,
    weeklyPrice: 400.00,
    period: "3 meses",
    description: "Aluguel comum — devolução ao final do contrato",
    summary: "Use a moto durante o período contratado e devolva ao término.",
    rentalType: "comum",
    purchaseAtEnd: false,
    included: [
      "Documentação em dia (IPVA + licenciamento)",
      "Troca de óleo por conta da locadora",
      "Pagamento semanal",
      "Carência mínima: 3 meses"
    ],
    highlighted: false
  },
  {
    id: 2,
    name: "Plano Anual",
    dailyPrice: 50.00,
    weeklyPrice: 350.00,
    period: "1 ano",
    description: "Aluguel comum com menor custo semanal",
    summary: "Plano com menor custo semanal para uso contínuo. Devolução ao final.",
    rentalType: "comum",
    purchaseAtEnd: false,
    included: [
      "Documentação em dia (IPVA + licenciamento)",
      "Troca de óleo por conta da locadora",
      "Pagamento semanal",
      "Carência: 12 meses"
    ],
    highlighted: false
  },
  {
    id: 3,
    name: "Plano Fidelidade",
    dailyPrice: 60.71,
    weeklyPrice: 425.00,
    period: "36 meses",
    description: "Aluguel com aquisição — a moto fica sua ao final!",
    summary: "Modelo de aluguel com aquisição: ao final dos 36 meses, a moto é transferida para o cliente.",
    rentalType: "aquisicao",
    purchaseAtEnd: true,
    included: [
      "Moto Zero Km na retirada",
      "Manutenções inclusas (peças de desgaste, óleo)",
      "Manutenção preventiva e corretiva",
      "Documentação em dia",
      "Ao final de 36 meses a moto é transferida para o cliente"
    ],
    highlighted: true
  }
];

// Benefícios válidos para todos os planos
export const beneficiosComuns = [
  { icon: "🛡️", title: "Proteção veicular", desc: "Cobertura contra roubo e furto" },
  { icon: "🚛", title: "Guincho 24h", desc: "No estado de SP, até 3x por mês" },
  { icon: "🛣️", title: "KM livre", desc: "Rode quanto quiser, sem limite de quilometragem" }
];

// TODO: Substituir por chamada à API /api/motos/publico quando implementado
export const motorcycles = [
  {
    id: 1,
    model: "DK 160",
    condition: "Zero Km",
    color: "Vermelha",
    image: "https://customer-assets.emergentagent.com/job_motolocadora/artifacts/15bxt961_IMG_2395.png",
    specs: ["162cc", "Partida elétrica", "Painel digital", "Freios a disco"],
    available: true
  },
  {
    id: 2,
    model: "DK 160", 
    condition: "Zero Km",
    color: "Azul",
    image: "https://customer-assets.emergentagent.com/job_motolocadora/artifacts/jpdtlzi1_IMG_2396.png",
    specs: ["162cc", "Partida elétrica", "Painel digital", "Freios a disco"],
    available: true
  },
  {
    id: 3,
    model: "DK 160",
    condition: "Zero Km",
    color: "Preta", 
    image: "https://customer-assets.emergentagent.com/job_motolocadora/artifacts/zdx3qkt8_IMG_2397.jpeg",
    specs: ["162cc", "Partida elétrica", "Painel digital", "Freios a disco"],
    available: true
  }
];

// Requisitos para contratação (Plano padrão)
export const requirements = {
  documents: [
    "CNH definitiva — categoria A",
    "Comprovante de residência no nome do cliente",
    "RG e CPF"
  ],
  financial: [
    "Caução: R$ 700,00 (devolvido ao final)",
    "Primeira semana adiantada",
    "Pagamentos semanais"
  ],
  process: [
    "Análise da documentação",
    "Assinatura do contrato",
    "Retirada da moto"
  ]
};

export const whatsappMessage = "Olá! Tenho interesse em alugar uma moto DK 160. Gostaria de fazer uma reserva!";